module.exports = __webpack_public_path__ + "assets/img/b0db322a7550fe44193e59ffdb694a84.svg";